(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thegee-home-showcase"] && !Shopify.designMode) return;
  try {
    
  const initTheGeeHomeShowcase = () => {
    document.querySelectorAll('.thegee-home-showcase__hero-viewport').forEach((viewport) => {
      if (viewport.dataset.initialized === 'true') return;

      const track = viewport.querySelector('.thegee-home-showcase__hero-track');
      if (!track) return;

      const slides = track.querySelectorAll('.thegee-home-showcase__hero-slide');
      if (slides.length < 2) return;

      viewport.dataset.initialized = 'true';

      let activeIndex = 0;
      let intervalId = null;
      const intervalMs = Number(viewport.dataset.interval || 4200);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const setActiveIndex = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        viewport.style.setProperty('--thegee-hero-active', activeIndex);
      };

      const stopAutoplay = () => {
        if (intervalId) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (reduceMotion.matches) return;

        intervalId = window.setInterval(() => {
          setActiveIndex(activeIndex + 1);
        }, intervalMs);
      };

      viewport.addEventListener('mouseenter', stopAutoplay);
      viewport.addEventListener('mouseleave', startAutoplay);
      viewport.addEventListener('focusin', stopAutoplay);
      viewport.addEventListener('focusout', startAutoplay);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      startAutoplay();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheGeeHomeShowcase, { once: true });
  } else {
    initTheGeeHomeShowcase();
  }

  } catch(e) { console.error(e); }
})();
})();
